import React from 'react';

const Schedule = () => {
  const events = [
    { date: "Jan 24", event: "World Championship Boxing Main Event", type: "Boxing", link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome" },
    { date: "Feb 08", event: "MMA Fight Night – Main Card", type: "MMA", link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome" },
    { date: "Feb 20", event: "European Night – Club Clash (Spanish-language)", type: "Soccer / UEFA", link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome" },
    { date: "Mar 15", event: "Kickboxing Grand Prix", type: "Kickboxing", link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome" },
    { date: "Apr 05", event: "Women's Soccer Championship Final", type: "Women's Football", link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome" }
  ];

  return (
    <section className="section" id="schedule">
      <div className="section-title">Upcoming Fight & Event Schedule</div>
      <div className="section-sub">Sample schedule for audience warming. Replace with live data if you integrate APIs. CTAs can lead to external event pages.</div>

      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Event</th>
            <th>Type</th>
            <th>Watch / Info</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event, index) => (
            <tr key={index}>
              <td>{event.date}</td>
              <td>{event.event}</td>
              <td>{event.type}</td>
              <td><a href={event.link}>Check Options →</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default Schedule;
